import { useEffect, useRef } from "react";

type PlayerStartupWatchdogInput = {
  generationKey: string;
  armed: boolean;
  timeoutMs?: number;
  onTimeout: () => void;
};

/** Fails a decoder generation that never reaches metadata readiness. */
export function usePlayerStartupWatchdog({
  generationKey,
  armed,
  timeoutMs = 25_000,
  onTimeout,
}: PlayerStartupWatchdogInput) {
  const onTimeoutRef = useRef(onTimeout);
  onTimeoutRef.current = onTimeout;

  useEffect(() => {
    if (!armed || !generationKey) return;
    const timeout = setTimeout(() => onTimeoutRef.current(), timeoutMs);
    return () => clearTimeout(timeout);
  }, [armed, generationKey, timeoutMs]);
}
